import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"

const ShippingAgentExtSystemAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Ext System", load = true, infoText, disabled = false, error, helperText}) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/ShippingAgentExtSystem"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default ShippingAgentExtSystemAutoComplete;
